export const ADD_CHAT_MESSAGE = 'CHAT_LOG/ADD_CHAT_MESSAGE';
export const CLEAR_CHAT_MESSAGES = 'CHAT_LOG/CLEAR_CHAT_MESSAGES';
